import React, { useState } from 'react';
import { apiPost } from '../utils/api';

const MacGenerator = () => {
  const [count, setCount] = useState(1);
  const [prefix, setPrefix] = useState('');
  const [result, setResult] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleGenerate = async () => {
    setLoading(true);
    setResult([]);
    try {
      const data = await apiPost('/api/mac/generate', { count, prefix });
      setResult(data.macs || []);
    } catch (e) {
      setResult(['Erro ao gerar MACs.']);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 max-w-lg mx-auto">
      <h2 className="text-2xl font-bold mb-4 text-gray-900">Gerador de MAC Address</h2>
      <p className="mb-4 text-gray-600">Gere endereços MAC aleatórios. Opcionalmente defina um prefixo (ex: 00:1A:2B).</p>
      <div className="flex gap-2 mb-4">
        <input
          type="number"
          min={1}
          max={100}
          value={count}
          onChange={e => setCount(Number(e.target.value))}
          className="w-24 p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          placeholder="Qtd."
        />
        <input
          type="text"
          value={prefix}
          onChange={e => setPrefix(e.target.value)}
          placeholder="Prefixo opcional"
          className="flex-1 p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
        <button
          onClick={handleGenerate}
          disabled={loading || count < 1}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
        >
          {loading ? 'Gerando...' : 'Gerar'}
        </button>
      </div>
      {result.length > 0 && (
        <div className="mt-4 p-4 bg-gray-50 rounded-lg">
          <ul className="space-y-1">
            {result.map((mac, i) => (
              <li key={i} className="font-mono text-gray-800">{mac}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default MacGenerator; 